"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ori-ui/icons");
var _material = require("@ori-ui/mui-bundle/material");
var _constants = require("../constants");
var _textInputData = require("../constants/textInputData");
var _jsxRuntime = require("react/jsx-runtime");
const styleOverrides = {
  inputRoot: {
    [`&[class*="${_material.filledInputClasses.root}"]`]: {
      paddingTop: 0,
      paddingLeft: 10,
      '& input': {
        padding: '12.5px 0'
      }
    }
  },
  paper: {
    border: `1px solid ${_constants.colors.oriGrey[500]}`,
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 5,
    boxShadow: 'none',
    transition: 'none'
  },
  listbox: {
    [`& .${_material.autocompleteClasses.option}`]: {
      fontSize: _constants.textInputData.input.size,
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: 10,
      paddingRight: 12
    },
    [`& .${_material.autocompleteClasses.option}::after`]: {
      content: '""',
      flexShrink: 0,
      display: 'block',
      overflow: 'hidden',
      width: '24px',
      height: '24px',
      background: 'transparent'
    },
    [`& .${_material.autocompleteClasses.option}.${_material.autocompleteClasses.focused}, & .${_material.autocompleteClasses.option}:focus`]: {
      backgroundColor: _constants.colors.primary.light
    },
    [`& .${_material.autocompleteClasses.option}.${_material.menuItemClasses.focusVisible}`]: {
      backgroundColor: _constants.colors.primary.light
    },
    [`& .${_material.autocompleteClasses.option}:hover`]: {
      backgroundColor: _constants.colors.primary.light
    },
    [`& .${_material.autocompleteClasses.option}[aria-selected="true"]::after`]: {
      content: _textInputData.selectedMark
    },
    [`& .${_material.autocompleteClasses.option}[aria-selected="true"].${_material.autocompleteClasses.option}[aria-selected="true"]`]: {
      backgroundColor: 'transparent'
    },
    [`& .${_material.autocompleteClasses.option}[aria-selected="true"].${_material.autocompleteClasses.focused}, & .${_material.autocompleteClasses.option}[aria-selected="true"]:focus`]: {
      backgroundColor: 'transparent'
    },
    [`& .${_material.autocompleteClasses.option}[aria-selected="true"].${_material.autocompleteClasses.option}[aria-selected="true"]:hover`]: {
      backgroundColor: _constants.colors.primary.light
    }
  },
  option: {}
};
const defaultProps = {
  clearIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {
    fontSize: "small"
  }),
  popupIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowDownThin, {
    fontSize: "medium"
  })
};
var _default = exports.default = {
  defaultProps,
  styleOverrides
};
